<template>
  <section class="TransactionFlow">
    <div class="d1">
      <div class="flex alignFlexEnd justifySpaceBetween">
        <div class="flex alignFlexEnd">
          <div>
            <label>查询条件</label>
            <el-select v-model="condition" placeholder="请选择">
              <el-option
                v-for="item in txCoditonList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mlr">
            <el-input
              :disabled="canBeInput"
              v-model.trim="formInline[condition]"
              placeholder="选择查询条件后输入"
            ></el-input>
          </div>
          <div>
            <label>状态</label>
            <el-select v-model="formInline.status" placeholder="请选择状态">
              <el-option
                v-for="item in txStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </div>
      </div>
    </div>
    <Table
      :baseData="baseData"
      :tableHeader="tableHeader"
      :listLoading="listLoading"
      @onClickBtn="onClickBtn"
      @handleCurrent="handleCurrentChange"
      :isShowPagination="true"
      :total="total"
      :pageSize="pageSize"
      :currentPage="pageNo"
    >
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="scope">
          <div class="opration check">
            <span @click="onClick(scope.row)">详情</span>
          </div>
        </template>
      </el-table-column>
    </Table>
    <detail-dialog-vue
      @close="isShowDetail = false"
      :isShowDialog="isShowDetail"
      headerText="详情"
    />
  </section>
</template>
<script>
import TxSearchForm from "./TxSearchForm.vue";
import DetailDialogVue from "./TxDetailDialog.vue";
import API from "@/api/api_query";
import { mapMutations } from "vuex";
import { txCoditonList, txStatusList } from "@/util/constant";
import dayjs from "dayjs";
export default {
  name: "TransactionFlow",
  components: {
    TxSearchForm,
    DetailDialogVue
  },
  data() {
    return {
      txCoditonList,
      txStatusList,
      condition: undefined,
      formInline: {
        blockHeight: undefined,
        txHash: undefined,
        appId: undefined,
        assetId: undefined,
        status: undefined
      },
      isShowDetail: false,
      pramas: {},
      baseData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      isShow: false,
      listLoading: true,
      tableHeader: this.tableHeader.transactionFlow.tableHeader
    };
  },
  computed: {
    canBeInput: function() {
      return this.condition === undefined;
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    ...mapMutations(["setDetail"]),
    onSubmit() {
      this.pageNo = 1;
      this.getDataList();
    },
    onReset() {
      this.condition = undefined;
      this.formInline = {
        blockHeight: undefined,
        txHash: undefined,
        appId: undefined,
        assetId: undefined,
        status: undefined
      };
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
      this.getDataList();
    },
    getDataList() {
      const pramas = {
        ...this.formInline,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      API.getTxList(pramas)
        .then((res = {}) => {
          const {
            data: { data: { records = [], total } = {}, code, msg = "" } = {}
          } = res;
          if (code === 200) {
            records.forEach(item => {
              item.createdTime = dayjs(item.createdTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              item.blockTime = dayjs(item.blockTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            });
            this.baseData = records;
            this.total = total;
          } else {
            console.error(msg);
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    onClick(row) {
      const payload = {
        name: "txDetail",
        detailObj: row
      };
      this.setDetail(payload);
      this.isShowDetail = true;
    },
    onClickBtn() {
      this.$emit("submit", "test");
    },
    submit() {
      this.$emit("submit", "test");
    },
    onClickClose() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
label {
  display: block;
  margin-bottom: 8px;
}
.d1 {
  padding: 32px;
}
.mlr {
  margin-right: 56px;
  margin-left: 12px;
}
.add {
  padding: 10px 16px;
  margin-top: 32px;
  gap: 8px;
  width: 84px;
  height: 40px;
  background: #ff9428;
  border-radius: 4px;
  font-family: "Microsoft YaHei UI";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;
  cursor: pointer;
}
</style>
